// extracted by mini-css-extract-plugin
export default {"root":"root--mlSWt","header":"header--fDxOE","heading":"heading--erRnA","body":"body--Sq9qb","footer":"footer--WOkyg","footerBtn":"footerBtn--ugdUF","close":"close--Tmb0K"};